import { render, staticRenderFns } from "./ConfiguratorEditor.vue?vue&type=template&id=273b5c22"
import script from "./ConfiguratorEditor.vue?vue&type=script&lang=js"
export * from "./ConfiguratorEditor.vue?vue&type=script&lang=js"
import style0 from "./ConfiguratorEditor.vue?vue&type=style&index=0&id=273b5c22&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports